/* Etsy-style behavior for the product photo lightbox (product-modal):
   one photo at a time, prev/next arrows, counter, click-to-zoom with cursor panning. */
(function () {
  'use strict';

  const CHEVRON_LEFT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>';
  const CHEVRON_RIGHT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>';

  function init(modal) {
    if (modal.dataset.etsyLightbox) return;
    modal.dataset.etsyLightbox = '1';

    const dialog = modal.querySelector('.product-media-modal__dialog');
    const content = modal.querySelector('.product-media-modal__content');
    if (!dialog || !content) return;

    const items = Array.from(content.children).filter((el) => el.hasAttribute('data-media-id'));
    if (!items.length) return;

    // Dawn closes a media-modal on ANY mouse pointerup. For Etsy behavior the
    // photo and controls must stay interactive - only the backdrop or X closes.
    modal.addEventListener(
      'pointerup',
      (event) => {
        if (
          event.target.closest('img.active') ||
          event.target.closest('.etsy-lightbox-arrow') ||
          event.target.closest('.product-media-modal__toggle')
        ) {
          event.stopPropagation();
        }
      },
      true
    );

    // Load the photos as soon as the lightbox opens instead of lazily.
    new MutationObserver(() => {
      if (!modal.hasAttribute('open')) return;
      items.forEach((el) => {
        if (el.tagName === 'IMG') el.loading = 'eager';
      });
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    let counter = null;

    const currentIndex = () => {
      const i = items.findIndex((el) => el.classList.contains('active'));
      return i < 0 ? 0 : i;
    };

    const unzoom = (el) => {
      el.classList.remove('is-zoomed');
      el.style.transformOrigin = '';
    };

    const updateCounter = () => {
      if (counter) counter.textContent = `${currentIndex() + 1} / ${items.length}`;
    };

    const show = (index) => {
      const target = items[(index + items.length) % items.length];
      items.forEach((el) => {
        el.classList.remove('active');
        unzoom(el);
      });
      target.classList.add('active');
      updateCounter();
    };

    if (items.length > 1) {
      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'etsy-lightbox-arrow etsy-lightbox-arrow--prev';
      prev.setAttribute('aria-label', 'Previous image');
      prev.innerHTML = CHEVRON_LEFT;
      prev.addEventListener('click', () => show(currentIndex() - 1));

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'etsy-lightbox-arrow etsy-lightbox-arrow--next';
      next.setAttribute('aria-label', 'Next image');
      next.innerHTML = CHEVRON_RIGHT;
      next.addEventListener('click', () => show(currentIndex() + 1));

      counter = document.createElement('div');
      counter.className = 'etsy-lightbox-counter';
      counter.setAttribute('aria-hidden', 'true');

      dialog.append(prev, next, counter);

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') show(currentIndex() + 1);
        if (event.key === 'ArrowLeft') show(currentIndex() - 1);
      });

      // Dawn's showActiveMedia() sets .active when the modal opens - keep the counter in sync.
      const observer = new MutationObserver(updateCounter);
      items.forEach((el) => observer.observe(el, { attributes: true, attributeFilter: ['class'] }));
      updateCounter();
    }

    const setOrigin = (img, clientX, clientY) => {
      const rect = content.getBoundingClientRect();
      const x = ((clientX - rect.left) / rect.width) * 100;
      const y = ((clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${Math.max(0, Math.min(100, x))}% ${Math.max(0, Math.min(100, y))}%`;
    };

    content.addEventListener('click', (event) => {
      const img = event.target.closest('img.active');
      if (!img) {
        // Click on the empty area around the photo closes the lightbox, like Etsy.
        if (event.target === content && typeof modal.hide === 'function') modal.hide();
        return;
      }
      if (img.classList.contains('is-zoomed')) {
        unzoom(img);
      } else {
        setOrigin(img, event.clientX, event.clientY);
        img.classList.add('is-zoomed');
      }
    });

    content.addEventListener('mousemove', (event) => {
      const img = content.querySelector('img.active.is-zoomed');
      if (img) setOrigin(img, event.clientX, event.clientY);
    });

    content.addEventListener(
      'touchmove',
      (event) => {
        const img = content.querySelector('img.active.is-zoomed');
        if (!img || !event.touches.length) return;
        event.preventDefault();
        setOrigin(img, event.touches[0].clientX, event.touches[0].clientY);
      },
      { passive: false }
    );
  }

  const initAll = () => document.querySelectorAll('product-modal').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
